// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"84e1274c","710":"a0786ea7","845":"4042236e","983":"0bceaf52"}[chunkId] + ".chunk.js";
};